import { useEffect, useState } from "react";
import {
  BonusDetail,
  CurrencyList,
  ExchangeRateData,
  UserWalletAddress,
  WithdrawFeesTypeListResponseList,
  WithdrawType,
  WithdrawTypeListResponseList
} from "../models";
import homeService from "../../home/services/home.service";
import { GetBalanceResponse } from "../../home/models";
import withdrawService from "../services/withdraw.service";
import { BlobContainerConsts } from "../../../models/constants/blobContainerConsts";
import { BLOB_IMAGE_URL } from "../../../config/appConfig";
import { Button, NumberInput, TextInput, Card, CardBody } from "../../../components/ui";
import localization from "../../../config/localization";
import { Dropdown } from "../../../components/ui/inputs";
import { formatUtcToLocalDateTime } from "../../../utils/dateTimeHelper";
import { ConfirmationModal, OtpModal } from "../../../components/ui/modals";
import { toastService as toast } from "../../../components/ui/toast/toast.service";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../store/hooks";
import { changeLoaderState } from "../../../reducers/appStateReducer";
import { DeviceType } from "../../../models/constants/deviceType";
import userDeviceStore from "../../../store/device.store";
export interface CreateABCCryptoWithdrawRequestProps {
  selectedWithdrawType: WithdrawTypeListResponseList;
  withdrawFlow: string;
  onBack: () => void;
}

export default function CreateABCCryptoWithdrawRequest({
  selectedWithdrawType,
  withdrawFlow,
  onBack,
}: CreateABCCryptoWithdrawRequestProps) {

  const [userBalance, setUserBalance] = useState<GetBalanceResponse | null>(null);
  const [withdrawFeesTypesList, setWithdrawFeesTypesList] = useState<WithdrawFeesTypeListResponseList[]>([]);
  const [selectedFeeType, setSelectedFeeType] = useState<WithdrawFeesTypeListResponseList | null>(null);
  const [cryptoCurrencies, setCryptoCurrencies] = useState<CurrencyList[]>([]);
  const [userWalletAddresses, setUserWalletAddresses] = useState<UserWalletAddress[]>([]);
  const [selectedUserWalletAddresses, setSelectedUserWalletAddresses] = useState<UserWalletAddress | null>(null);
  const [exchangeRates, setExchangeRates] = useState<ExchangeRateData[]>([]);
  const [selectedCryptoCurrency, setSelectedCryptoCurrency] = useState<CurrencyList | null>(null);
  const [amount, setAmount] = useState<string>("");
  const [amountError, setAmountError] = useState<string | null>(null);
  const [feeAmount, setFeeAmount] = useState<number>(0);
  const [receivedAmount, setReceivedAmount] = useState<number>(0);
  let [convertedINRForOneCrypto, setConvertedINRForOneCrypto] = useState<number | null>(null);
  let [convertedCryptoAmount, setconvertedCryptoAmount] = useState<number>(0);
  const [selectedWalletIndex, setSelectedWalletIndex] = useState<number>(0);
  const [isAddingNewAddress, setIsAddingNewAddress] = useState<boolean>(false);
  const [newWalletAddress, setNewWalletAddress] = useState<string>("");
  const [walletAddressError, setWalletAddressError] = useState<string>("");
  const [showActiveBonusCancelModal, setShowActiveBonusCancelModal] = useState<boolean>(false);
  const [activeBonusList, setActiveBonusList] = useState<string[]>([]);
  const [removedFreeSpinBonusIdList, setRemovedFreeSpinBonusIdList] = useState<string[]>([]);
  const [showWalletAddressVerificationModal, setShowWalletAddressVerificationModal] = useState<boolean>(false);
  const [mobileVerificationErrorMessage, setMobileVerificationErrorMessage] = useState<string>("");
  const [nextclick, setNextclick] = useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const deviceType = userDeviceStore((state) => state.deviceType);
  const accessModeSource = userDeviceStore((state) => state.accessModeSource);

  useEffect(() => {
    dispatch(changeLoaderState(true));
    init();
  }, []);

  const init = async () => {
    const balanceResponse = await homeService.fetchUserBalance();
    if (balanceResponse.isSuccess && balanceResponse.data) {
      setUserBalance(balanceResponse.data);
    }
    const fees = await withdrawService.getWithdrawFeesTypesList();
    if (fees && fees.length > 0) {
      setWithdrawFeesTypesList(fees);
      setSelectedFeeType(fees[0]);
    }
    const currencies = await withdrawService.getCryptoCurrenciesList();
    if (currencies && currencies.length > 0) {
      setCryptoCurrencies(currencies);
    }
    const addresses = await withdrawService.getUserWalletAddress();
    if (addresses && addresses.length > 0) {
      setUserWalletAddresses(addresses);
      setSelectedUserWalletAddresses(addresses[0])
      setSelectedWalletIndex(0);
    }
    const rates = await withdrawService.getExchangeRates(1);
    if (rates && rates.length > 0) {
      setExchangeRates(rates);
    }
    dispatch(changeLoaderState(false));
  };

  const handleCryptoCurrencyChange = async (value: string) => {
    const currency = cryptoCurrencies.find((currency) => currency.crypto_currency === value);
    if (currency) {
      if (currency.network_id !== selectedCryptoCurrency?.network_id) {
        const cryptoMinimumAmount = calculateminimumINR(currency);
        selectedWithdrawType.minimumAmount = selectedWithdrawType.minimumAmount > cryptoMinimumAmount ? selectedWithdrawType.minimumAmount : cryptoMinimumAmount;
      }

      if (selectedFeeType?.amounttype === "Fix Amount" && selectedFeeType.usersfreecount <= 0) {
        selectedWithdrawType.minimumAmount = selectedWithdrawType.minimumAmount + selectedFeeType.fee;
      }
      setSelectedCryptoCurrency(currency);

      if (amount) {
        await handleAmountChange(amount);
      }
    }
  };

  const calculateminimumINR = (currency: CurrencyList): number => {
    const rate = exchangeRates.find((rate) => rate.crypto_currency === currency.crypto_currency);
    if (rate) {
      const totalCryptoReceived = rate.receivable_amount + rate.network_fee;
      setConvertedINRForOneCrypto(1 / totalCryptoReceived)
      const minINRNeeded = rate.minimum_withdrawal_limit * (1 / totalCryptoReceived);
      return Math.ceil(minINRNeeded);
    }
    return 0;
  };

  const calculateINRToCrypto = async (receivedAmount: number) => {
    const rates = await withdrawService.getExchangeRates(receivedAmount);
    if (rates && rates.length > 0) {
      const result = rates.find(
        (data) => data.crypto_currency === selectedCryptoCurrency?.crypto_currency
      );

      setconvertedCryptoAmount(result?.receivable_amount ?? 0);
    }
  };

  const handleAmountChange = async (value: string) => {
    const num = Number(value);

    if (num === 0) {
      setAmountError(null);
      setFeeAmount(0);
      setReceivedAmount(0);
      return;
    }

    if (isNaN(num)) {
      setAmountError(localization.enter_valid_amount);
      setFeeAmount(0);
      setReceivedAmount(0);
      return;
    }

    if (num > (userBalance?.withdrawBalance ?? 0)) {
      setAmountError(localization.amount_less_than_balance);
      setFeeAmount(0);
      setReceivedAmount(0);
      return;
    }

    if (
      num < selectedWithdrawType?.minimumAmount ||
      num > selectedWithdrawType?.maximumAmount
    ) {
      setAmountError(
        `${localization.amount_between} \u20B9${selectedWithdrawType?.minimumAmount} ${localization.and} \u20B9${selectedWithdrawType?.maximumAmount}`
      );
      setFeeAmount(0);
      setReceivedAmount(0);
      return;
    }

    if ((selectedFeeType?.usersfreecount ?? 0) <= 0) {
      if (selectedFeeType?.amounttype === "Fix Amount") {
        if (num - selectedFeeType.fee < 0) {
          setAmountError(localization.amount_less_than_fee_amount);
          setFeeAmount(0);
          setReceivedAmount(0);
          return;
        }
        setFeeAmount(selectedFeeType.fee)
        setReceivedAmount(num - selectedFeeType.fee)
        await calculateINRToCrypto(num - selectedFeeType.fee);
      }
      else {
        const feeAmount = Math.floor((num * (selectedFeeType?.fee ?? 0) / 100))
        if (feeAmount < 0) {
          setAmountError(localization.amount_less_than_fee_amount);
          setFeeAmount(0);
          setReceivedAmount(0);
          return;
        }
        selectedWithdrawType.minimumAmount = selectedWithdrawType.name !== null && selectedWithdrawType.name === WithdrawType.ABCCrypto && num > selectedWithdrawType.minimumAmount ? selectedWithdrawType.minimumAmount + feeAmount : selectedWithdrawType.minimumAmount;
        setFeeAmount(feeAmount)
        setReceivedAmount(num - feeAmount)
        await calculateINRToCrypto(num - feeAmount);
      }
    }

    setAmount(value);
    setAmountError(null);
  };

  const HandleFeeTypeSelect = async (feeType: WithdrawFeesTypeListResponseList) => {
    if (Number(amount) > 0) {
      const num = Number(amount);
      if ((feeType?.usersfreecount ?? 0) <= 0) {
        if (feeType?.amounttype === "Fix Amount") {
          if (num - feeType.fee < 0) {
            setAmountError(localization.amount_less_than_fee_amount);
            return;
          }
          setFeeAmount(feeType.fee)
          setReceivedAmount(num - feeType.fee)
          await calculateINRToCrypto(num - feeType.fee);
        }
        else {
          const feeAmount = Math.floor((num * (feeType?.fee ?? 0) / 100))
          if (feeAmount < 0) {
            setAmountError(localization.amount_less_than_fee_amount);
            return;
          }
          setFeeAmount(feeAmount)
          setReceivedAmount(num - feeAmount)
          await calculateINRToCrypto(num - feeAmount);
        }
      }
      else {
        setFeeAmount(0)
        setReceivedAmount(num)
        await calculateINRToCrypto(num);
      }
    }
    setSelectedFeeType(feeType);
  };

  const handleNextClick = async () => {
    if (nextclick) {
      return;
    }

    try {
      setNextclick(true);

      if (!amount) {
        setAmountError(localization.valid_enter_amount);
        return;
      }

      if (isAddingNewAddress && !newWalletAddress && (selectedWalletIndex === userWalletAddresses.length)) {
        setWalletAddressError(localization.add_wallet_aadress);
        return;
      }

      const activeBonusCount = await withdrawService.getUserActiveBonusCount();
      if (activeBonusCount && activeBonusCount.activebonuscount > 0) {

        const bonusDetailsArray: BonusDetail[] = Array.isArray(activeBonusCount.bonusdetails)
          ? activeBonusCount.bonusdetails
          : activeBonusCount.bonusdetails
            ? (JSON.parse(activeBonusCount.bonusdetails) as BonusDetail[])
            : [];

        const formattedBonusList = bonusDetailsArray
          .sort(
            (a, b) =>
              Number(!!a.startDate && !!a.endDate) -
              Number(!!b.startDate && !!b.endDate)
          )
          .map((bonus) => {
            if (bonus.startDate && bonus.endDate) {
              return `${bonus.name} (From ${formatUtcToLocalDateTime(
                bonus.startDate,
                false
              )} until ${formatUtcToLocalDateTime(
                bonus.endDate,
                false
              )})`;
            }
            return bonus.name;
          });

        setActiveBonusList(formattedBonusList ?? []);

        if (activeBonusCount.freespinbonuscount > 0) {
          const freeSpinBonusDetails = await withdrawService.getUserActiveFreeSpinBonusDetails();
          if (freeSpinBonusDetails && freeSpinBonusDetails.length > 0) {
            const itemsToRemove: typeof freeSpinBonusDetails = [];
            for (const bonusDetail of freeSpinBonusDetails) {
              if (bonusDetail.qtechBonusId) {
                const request = {
                  bonusId: bonusDetail.qtechBonusId,
                  playerId: bonusDetail.providerUserId,
                };
                const freeSpinBonusHistory =
                  await withdrawService.getFreeSpinBonusHistoryFromProvider(request);

                if (freeSpinBonusHistory && freeSpinBonusHistory.status.toLowerCase() !== "promoted") {
                  itemsToRemove.push(bonusDetail);
                }
              }
            }
            freeSpinBonusDetails.filter(
              (item) => !itemsToRemove.includes(item)
            );

            setRemovedFreeSpinBonusIdList(itemsToRemove.map((item) => item.qtechBonusId));

            if (freeSpinBonusDetails.length > 0) {
              setShowActiveBonusCancelModal(true);
            }
            else if (activeBonusCount.activebonuscount - activeBonusCount.freespinbonuscount > 0) {
              setShowActiveBonusCancelModal(true);
            }
            else {
              await handleCryptoWithdrawSubmit();
            }
          }
          else {
            setShowActiveBonusCancelModal(true);
          }
        }
        else {
          setShowActiveBonusCancelModal(true);
        }
      }
      else {
        await handleCryptoWithdrawSubmit();
      }
    }
    finally {
      setNextclick(false);
    }
  };

  const handleCryptoWithdrawSubmit = async () => {
    if (isAddingNewAddress && newWalletAddress && (selectedWalletIndex === userWalletAddresses.length)) {
      withdrawService.sendMobileVerificationCodeForWalletAddress().then((response) => {
        if (response.isSuccess) {
          setTimeout(() => {
            setShowWalletAddressVerificationModal(true);
          }, 1000);
        }
      });
    }
    else {
      await handleCryptoWithdrawInitiate();
    }
  };

  const handleResendMobileVerificationCode = () => {
    withdrawService.sendMobileVerificationCodeForWalletAddress().then((response) => {
      if (response.isSuccess) {
        setMobileVerificationErrorMessage("");
      }
    });
  };

  const handleCryptoWithdrawInitiate = async () => {
    const walletAddress: string | null = isAddingNewAddress && (selectedWalletIndex === userWalletAddresses.length)
      ? newWalletAddress
      : selectedUserWalletAddresses?.walletaddress ?? null;
    const response = await withdrawService.cryptoWithdrawInitiate(
      selectedWithdrawType,
      Number(amount),
      receivedAmount,
      feeAmount,
      selectedFeeType,
      showActiveBonusCancelModal,
      removedFreeSpinBonusIdList,
      withdrawFlow,
      selectedCryptoCurrency,
      walletAddress,
      accessModeSource.sourceType
    );

    if (response.success) {
      navigate("/withdraw-under-process");
    }
    else {
      toast.error(response.message);
    }
  }

  const handleVerifyMobileVerificationCode = async (otp: string) => {
    const response =
      await withdrawService.verifyMobileVerificationCodeForWalletAddress(otp);
    if (response.isSuccess) {
      await userWalletAddressSubmit();
      setTimeout(async () => {
        setShowWalletAddressVerificationModal(false);
      }, 1000);
    } else {
      setMobileVerificationErrorMessage(response.message);
    }
  };

  const userWalletAddressSubmit = async () => {
    const response = await withdrawService.walletAddressSubmit(newWalletAddress);
    if (response.isSuccess) {
      await handleCryptoWithdrawInitiate();
    }
    else {
      toast.error(response.message);
    }
  }

  const handleCloseMobileVerificationModal = () => {
    setShowWalletAddressVerificationModal(false);
    setMobileVerificationErrorMessage("");
  };

  const label = (
    <span className="flex flex-wrap items-center gap-1 mb-1">
      <span className="text-[#A9A9A9] font-medium text-base mr-1">
        {localization.amount}
      </span>

      {selectedCryptoCurrency && (
        <span className="text-[#A9A9A9] text-xs flex items-center gap-1 flex-wrap mb-1">
          <span className="text-[#A9A9A9] text-xs font-medium">
            ({localization.min_text} {"\u20B9"}
            {selectedWithdrawType?.minimumAmount?.toFixed(2)} -
            {localization.max_text} {"\u20B9"}
            {selectedWithdrawType?.maximumAmount?.toFixed(2)})
          </span>
        </span>
      )}
    </span>
  );

  const activeBonusDescription = (
    <ul className="mt-2 list-disc pl-5 text-left text-sm text-[#111111]">
      {activeBonusList.map((b, i) => (
        <li key={i}>{b}</li>
      ))}
    </ul>
  );

  const content = (
    <div className="p-4">

      <div className="w-full flex justify-end items-center mb-3">
        <div className="flex items-center bg-[#1A1A1A] border border-[#2E2E2E] rounded-[6px] px-2 py-1 gap-2">
          <img
            src={
              selectedWithdrawType?.logoUrl &&
              `${BLOB_IMAGE_URL}${BlobContainerConsts.WithdrawType}/${selectedWithdrawType?.logoUrl}`
            }
            alt={selectedWithdrawType?.name}
            className="w-6 h-6 object-contain"
          />
          <p className="text-sm font-bold text-white">
            {selectedWithdrawType?.accountName}
          </p>
          <Button
            onClick={onBack}
            className="text-xs font-medium bg-[#460413] text-[#FFBDCC] px-2 py-2 rounded-full hover:bg-[#8a0024] transition"
          >
            {localization.change_btn}
          </Button>
        </div>
      </div>

      <div className="mt-10">
        <span className="font-normal mr-1 text-[#DBDBDB] text-base">{localization.Widthdrawable_Bal}</span>
        <span className="text-white font-semibold text-base">{"\u20B9"}{(userBalance?.withdrawBalance ?? 0).toFixed(2)}</span>
      </div>

      <div className="mt-8">
        <Dropdown
          label={localization.crypto_network}
          options={cryptoCurrencies.map((currency) => ({
            imgSrc: `/icons/ic-${currency.crypto_currency.toLowerCase()}.png`,
            label: `${currency.crypto_currency} (${currency.blockchain})`,
            value: currency.crypto_currency,
          }))}
          placeholder={localization.select_crypto_currency}
          value={selectedCryptoCurrency?.crypto_currency || undefined}
          onChange={(value) => handleCryptoCurrencyChange(value)}
        />
      </div>

      <div className="mt-8">
        <NumberInput
          label={label}
          placeholder={localization.enter_amount}
          error={amountError}
          value={amount}
          maxLength={8}
          onChange={(e) => setAmount(e.target.value)}
          min={selectedWithdrawType?.minimumAmount}
          max={selectedWithdrawType?.maximumAmount}
          onInput={(e) => handleAmountChange(e.currentTarget.value)}
          onCopy={(e) => e.preventDefault()}
          onPaste={(e) => e.preventDefault()}
        />
      </div>

      {feeAmount > 0 && receivedAmount > 0 && (
        <div className="mt-3">
          <p className="text-[#C7C7CC] text-sm font-normal">
            <span>{localization.fee}</span>
            <span className="ml-1">{"\u20B9"}{feeAmount.toFixed(2)}</span>
            <span className="mx-2">{"-"}</span>
            <span>{localization.fees_info}</span>
            <span className="ml-1">{"\u20B9"}{receivedAmount.toFixed(2)}</span>
          </p>
        </div>
      )}

      {convertedCryptoAmount > 0 && (
        <div className="mt-6">
          <TextInput
            value={convertedCryptoAmount.toString()}
            disabled={true}
            iconSrc={`/icons/ic-${selectedCryptoCurrency?.crypto_currency.toLowerCase()}.png`}
            iconPosition="left"
          />

          <p className="flex items-center gap-2">
            <img src="/icons/ic-bolt.svg" className="w-4 h-4" alt="bolt" />
            <span>
              {`\u20B9${convertedINRForOneCrypto?.toFixed(2)}`} INR = 1{" "}
              {selectedCryptoCurrency?.crypto_currency}
            </span>
          </p>

          <p>
            {`${localization.crypto_withdraw_info1} ${convertedCryptoAmount} ${selectedCryptoCurrency?.crypto_currency} ${localization.crypto_withdraw_info2} ${amount} ${localization.crypto_withdraw_info3}`}
          </p>
        </div>
      )}

      <div className="mt-10">
        <p className="text-white text-base font-medium mb-4">
          {localization.select_category_lbl}
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {withdrawFeesTypesList.map((item) => {
          const isSelected = item.id === selectedFeeType?.id;

          return (
            <div
              key={item.id}
              onClick={() => HandleFeeTypeSelect(item)}
              className={`relative cursor-pointer rounded-[4px] border ${isSelected ? "border-[#257767]" : "border-[#353535]"}`}
            >
              <div className="absolute top-0 right-0">
                <div className="rounded-tr-[3px] rounded-bl-[6px] border-l border-b border-[#2E2E2E] bg-[#1A1A1A] px-2 py-1.5 text-[10px] font-semibold text-[#D1D1D1]">
                  {item.description}
                </div>
              </div>

              <div className="flex items-center justify-center gap-3 mt-8 px-4">
                <div className="w-14 h-14 rounded-[10px] bg-[#181818] flex items-center justify-center">
                  <img
                    src={
                      item.icon
                        ? `${BLOB_IMAGE_URL}${BlobContainerConsts.WithdrawFee}/${item.icon}`
                        : "/img/icons/default-fee.png"
                    }
                    alt={item.displayname}
                    className="w-8 h-8 object-contain"
                  />
                </div>

                <span className="text-[#F5F5F5] font-medium text-base">
                  {item.displayname}
                </span>
              </div>

              <div className="my-3 border-t border-[#2B2B2B]" />

              <p
                className={`text-center text-sm pb-3 font-semibold uppercase text-[#C7C7CC]`}>
                {localization.fee}
                <span
                  className={`ml-2 ${item.usersfreecount > 0
                    ? "text-[#47D7A3]"
                    : item.amounttype === "Fix Amount"
                      ? "text-[#EB7C7E]"
                      : "text-[#EB7C7E]"
                    }`}
                >
                  {item.usersfreecount > 0 ? (
                    <>
                      {"\u20B9"}00.00
                    </>
                  ) : item.amounttype === "Fix Amount" ? (
                    <>
                      {"\u20B9"}
                      {item.fee.toFixed(2)}
                    </>
                  ) : (
                    <>
                      {item.fee.toFixed(2)}{"\u0025"}
                    </>
                  )}
                </span>
              </p>
            </div>
          );
        })}
      </div>

      <p className="mt-10 font-medium text-sm text-[#A9A9A9]">{localization.add_wallet_address}</p>

      <div className="mt-6 space-y-3">
        {userWalletAddresses.map((item, index) => {
          const isSelected = index === selectedWalletIndex;

          return (
            <div
              key={item.walletaddress ?? index}
              onClick={() => {
                setSelectedWalletIndex(index);
                setSelectedUserWalletAddresses(item);
              }}
              className={`cursor-pointer rounded-md px-4 py-3 border 
          ${isSelected ? "border-2 border-primary" : "border-[#2E2E2E]"}
          bg-[#0F0F0F] text-white`}
            >
              {item.walletaddress}
            </div>
          );
        })}

        {isAddingNewAddress && (

          <TextInput
            type="text"
            value={newWalletAddress}
            error={walletAddressError}
            onClick={() => {
              setSelectedWalletIndex(userWalletAddresses.length);
              setSelectedUserWalletAddresses(null);
            }}
            onChange={(e) => setNewWalletAddress(e.target.value)}
            placeholder="Enter wallet address"
            isFocusVisible={false}
            inputClassName={`border rounded-md px-4 py-3 ${selectedWalletIndex === userWalletAddresses.length ? "border-2 border-primary" : ""}`}
            autoFocus={selectedWalletIndex === userWalletAddresses.length}
          />

        )}

      </div>

      {userWalletAddresses.length < 3 && !isAddingNewAddress && (

        <Button
          onClick={() => {
            setIsAddingNewAddress(true);
            setSelectedWalletIndex(userWalletAddresses.length);
            setSelectedUserWalletAddresses(null);
            setNewWalletAddress("");
          }}
          className="mt-4 w-full flex items-center justify-center gap-2
      border-2 border-[#02211B] text-white font-semibold text-sm
      py-4 rounded-md hover:bg-[#102F2B] transition"
        >
          <div className="flex items-center justify-center gap-2">
            <img src={"/icons/ic-plus.svg"} alt="save-image" className="w-5 h-5" />
            <span>{localization.add_another_address} {localization.uptp_3}</span>
          </div>
        </Button>
      )}

      <Button
        type="button"
        className={`mt-8 w-full rounded-lg py-4 text-white bg-primary-gradient font-semibold hover:opacity-90 transition-all duration-200 ${nextclick ? "opacity-50 cursor-not-allowed" : ""}`}
        onClick={handleNextClick}
        disabled={nextclick}
      >
        {nextclick ? localization.processing : localization.next}
      </Button>

      {showActiveBonusCancelModal && (
        <ConfirmationModal
          isOpen={showActiveBonusCancelModal}
          onConfirm={() => {
            handleCryptoWithdrawSubmit();
          }}
          onCancel={() => {
            setShowActiveBonusCancelModal(false);
          }}
          description={activeBonusDescription}
          icon={"/icons/ic-info.svg"}
          blurColor="bg-[#FFE6CC]"
          title={localization.confirm_withdraw}
          confirmText={localization.confirm_btn}
          cancelText={localization.cancel_btn}
        />
      )}

      <OtpModal
        open={showWalletAddressVerificationModal}
        onSubmit={(otp) => {
          handleVerifyMobileVerificationCode(otp);
        }}
        showTimer={true}
        errorMessage={mobileVerificationErrorMessage}
        onResend={() => handleResendMobileVerificationCode()}
        onClose={handleCloseMobileVerificationModal}
      />
    </div>
  );

  return deviceType !== DeviceType.Web ? (
    content
  ) : (
    <Card>
      <CardBody showGradient>
        <div className="w-full max-w-4xl mx-auto">
          {content}
        </div>
      </CardBody>
    </Card>
  );
}